/**
 * Busca um arquivo com base em uma string de url
 *
 * @type {(url: string) => Promise<File | null>}
 */
export async function getFileFromUrl(url) {
  if (!url) return null;

  try {
    const response = await fetch(url);
    const blob = await response.blob();
    return new File([blob], 'file', { type: blob.type });
  } catch {
    return null;
  }
}